const version = "2.0.0-alpha.14";
export {
  version
};
//# sourceMappingURL=version.mjs.map
